import { Progress as ProgressPrimitive } from "radix-ui"
import { cva, VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/utils'

const progressVariants = cva('', {
  variants: {
    color: {
      red: 'bg-red-500',
      orange: 'bg-orange-500',
      green: 'bg-green-500',
      yellow: 'bg-yellow-500',
      neutral: 'bg-neutral-500',
    },
  },
  defaultVariants: {
    color: 'neutral',
  },
})

function Progress({
  className,
  value,
  color,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> &
  VariantProps<typeof progressVariants>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        'bg-primary/20 relative h-2 w-full overflow-hidden rounded-full',
        className,
        progressVariants({ color }),
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="bg-primary h-full w-full flex-1 transition-all"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
